import { render, staticRenderFns } from "./SourceMp3.vue?vue&type=template&id=975947c2&scoped=true"
import script from "./SourceMp3.vue?vue&type=script&lang=js"
export * from "./SourceMp3.vue?vue&type=script&lang=js"
import style0 from "./SourceMp3.vue?vue&type=style&index=0&id=975947c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975947c2",
  null
  
)

export default component.exports